"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPROVAL_LEVELS_MAX = exports.APPROVAL_LEVELS_MIN = exports.ROLES = exports.APPROVAL_STEP_TONES = exports.REIMBURSEMENT_CATEGORY_LABELS = exports.DEFAULT_LEAVE_QUOTAS = exports.LEAVE_TYPE_TONES = exports.LEAVE_TYPE_LABELS = void 0;
exports.LEAVE_TYPE_LABELS = {
    annual: 'Annual Leave',
    sick: 'Sick Leave',
    personal: 'Personal',
    maternity: 'Maternity Leave',
    paternity: 'Paternity Leave',
    unpaid: 'Unpaid Leave'
};
exports.LEAVE_TYPE_TONES = {
    annual: 'blue',
    sick: 'red',
    personal: 'violet',
    maternity: 'amber',
    paternity: 'amber',
    unpaid: 'gray'
};
exports.DEFAULT_LEAVE_QUOTAS = {
    annual: 12,
    sick: 12,
    personal: 3,
    maternity: 90,
    paternity: 7,
    unpaid: 0
};
exports.REIMBURSEMENT_CATEGORY_LABELS = {
    travel: 'Travel',
    meals: 'Meals',
    equipment: 'Equipment',
    software: 'Software',
    training: 'Training',
    other: 'Other'
};
exports.APPROVAL_STEP_TONES = {
    pending: 'amber',
    approved: 'green',
    rejected: 'red'
};
exports.ROLES = {
    SUPER_ADMIN: 'super_admin',
    HR_ADMIN: 'hr_admin',
    EMPLOYEE: 'employee'
};
exports.APPROVAL_LEVELS_MIN = 1;
exports.APPROVAL_LEVELS_MAX = 4;
//# sourceMappingURL=index.js.map